import React from 'react'
import {TbMessage} from 'react-icons/tb'
import styles from '../styles/msg.css'
import {motion} from 'framer-motion'
import {Link} from 'react-router-dom'

const Msg = () => {
  return (
    <div className='msg'>
        <motion.h2
        initial={{y:30, opacity:0}}
        whileInView={{y:0,opacity:1}}
        transition={{duration:0.5, delay:0.1}}
        style={{
          padding: "10px"
        }}>Interested in collaborating with me?</motion.h2>
        <motion.p
        initial={{y:30, opacity:0}}
        whileInView={{y:0,opacity:1}}
        transition={{duration:0.5, delay:0.1}}
        style={{
          maxWidth: "700px"
        }} className='caption title'>I’m always open to discussing product design work or partnership opportunities.</motion.p>
        {/* <Link
        to="/contact"
        initial={{y:30, opacity:0}}
        whileInView={{y:0,opacity:1}}
        transition={{duration:0.5, delay:0.1}}
        className='msg-btn' href=""><TbMessage/> Start a conversation</Link> */}
        <div className='msg_btn'>
        <motion.a
        href="mailto:lexypaul14@gmail.com"
        initial={{y:30, opacity:0}}
        target="_blank"
        whileInView={{y:0,opacity:1}}
        transition={{duration:0.5, delay:0.1}}
        className='msg-btn'><TbMessage/> Start a conversation</motion.a>
        <motion.a
        href="https://www.linkedin.com/in/lexypaul/"
        initial={{y:30, opacity:0}}
        target="_blank"
        whileInView={{y:0,opacity:1}}
        transition={{duration:0.5, delay:0.1}}
        className='msg-btn'>Go to Linkedin</motion.a>
        </div>
    </div>
  )
}

export default Msg